(function(window, document) {
    'use strict'

    const internal = window.RTAnalyticsInternal
    const pageId = createId()

    function createId() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
            return window.crypto.randomUUID()
        }

        return [Date.now(), Math.random().toString(16).slice(2)].join('-')
    }

    function cloneSerializable(value, fallback) {
        if (typeof value === 'undefined') {
            return fallback
        }

        try {
            return JSON.parse(JSON.stringify(value))
        } catch (error) {
            return fallback
        }
    }

    function createEvent(name, payload, options, version) {
        const eventOptions = options || {}
        const createdAt = Date.now()

        return {
            id: eventOptions.eventId || eventOptions.dedupeKey || createId(),
            dedupeKey: eventOptions.dedupeKey || null,
            name: name,
            version: version || 1,
            source: eventOptions.source || 'application',
            payload: cloneSerializable(payload, {}),
            context: Object.assign({}, cloneSerializable(eventOptions.context, {}), {
                pageId: pageId,
                url: window.location.origin + window.location.pathname,
                path: window.location.pathname,
                title: document.title
            }),
            createdAt: createdAt,
            expiresAt: createdAt + internal.config.eventTtlMs
        }
    }

    internal.eventFactory = Object.freeze({
        createEvent: createEvent,
        cloneSerializable: cloneSerializable,
        getPageId: function() {
            return pageId
        }
    })
})(window, document)
